var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHierarchyArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 3c0-1.103-.897-2-2-2H3c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V3Zm-4.219 5.531-3.25 3.25a.75.75 0 0 1-1.06-1.06l2.72-2.718-2.72-2.719a.75.75 0 0 1 1.06-1.06l3.25 3.245a.747.747 0 0 1 0 1.06v.002Z"
})));
export default SvgHierarchyArrowIcon;